export default{
  // eslint-disable-next-line no-unused-vars
  SET_AUTH(state, { accessToken, tokenType, expiresIn, role, isUpdateTnc }) {
    state.accessToken = accessToken;
    state.tokenType = tokenType;
    state.expiresIn = expiresIn;
    state.role = role;
    state.isAdmin = role === state.roleList.ADMINISTRATOR;
    state.isSuperAdmin = role === state.roleList.SUPERADMIN;
    state.isArtist = role === state.roleList.ARTIST;
    state.isFinance = role === state.roleList.FINANCE;
    state.isOps = role === state.roleList.OPS;
    state.isReviewer = role === state.roleList.REVIEWER;
    state.isRecruitment = role === state.roleList.RECRUITMENT;
    state.isUpdateTnc = isUpdateTnc;
  },
  SET_USER(state, { user }) {
    state.user = user;
  },
  UPDATE_TOC(state, { toc }) {
    state.isUpdateTnc = toc;
  },
};



// WEBPACK FOOTER //
// ./src/stores/Auth/mutations/index.js